import React from "react";
import { Field, FieldArray, getIn } from "formik";
import classNames from "classnames";
import { Error } from "@peracto/peracto-ui";

import { DAY_OPTIONS } from "./constants";

export const DayOfWeekPicker = ({ name, label = "Days of Week" }) => (
    <Field name={name}>
        {({ field, form }) => {
            const error = getIn(form.errors, name);
            const values = field.value || [];

            return (
                <FieldArray name={name}>
                    {({ push, remove }) => (
                        <div className="mb-3" data-testid={`${name}-picker`}>
                            <label className="d-block mb-1">{label}</label>
                            <div
                                className="d-flex flex-wrap"
                                style={{ gap: "0.5rem" }}
                            >
                                {DAY_OPTIONS.map((day) => {
                                    const checked = values.includes(
                                        day.value
                                    );

                                    return (
                                        <button
                                            type="button"
                                            key={day.value}
                                            data-testid={`${name}-day-${day.value}`}
                                            aria-pressed={checked}
                                            className={classNames(
                                                "btn btn-sm",
                                                checked
                                                    ? "btn-primary"
                                                    : "btn-outline-secondary"
                                            )}
                                            disabled={form.isSubmitting}
                                            onClick={() => {
                                                if (checked) {
                                                    remove(
                                                        values.indexOf(
                                                            day.value
                                                        )
                                                    );
                                                } else {
                                                    push(day.value);
                                                }
                                            }}
                                        >
                                            {day.label}
                                        </button>
                                    );
                                })}
                            </div>
                            {error && <Error error={error} name={label} />}
                        </div>
                    )}
                </FieldArray>
            );
        }}
    </Field>
);
